import Form from 'react-bootstrap/Form'

import InputLayout from '../InputLayout/InputLayout'
import Icon from '../../Icon/Icon'

const InputEmail = ({
    color = 'blue',
    disabled,
    error,
    id,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    touched,
    value,
    ...props
}) => {
    return (
        <InputLayout label={label} error={error} color={color} touched={touched}>
            <Icon
                name="email"
                className={`position-absolute ps-3 top-50 translate-middle-y ${disabled && 'opacity-50'}`}
            />
            <Form.Control
                type="email"
                className={'rounded-0 ps-8 pe-3 text-formPrimary'}
                isInvalid={error && touched}
                placeholder={placeholder}
                name={name}
                id={id}
                value={value}
                required
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                {...props}
            />
        </InputLayout>
    )
}

export default InputEmail
